module.exports = __webpack_public_path__ + "static/media/15.3c3934f1.mp3";